import { PresentationInvoicingBatchExport } from '@studyportals/sp-lord-business-interface';
import { Event } from './event';

export class InvoiceBatchExportAcquiredEvent extends Event<PresentationInvoicingBatchExport> {}
